{
  "name": "@getcronit/pylon-dev",
  "type": "module",
  "version": "2.0.0-canary-20260328200015.71367b7a9e557a2e0de9a6348e56d450fce33de4",
  "description": "CLI for creating a Pylon",
  "scripts": {
    "build": "rimraf ./dist && esbuild ./src/index.ts --bundle --platform=node --target=node18 --format=esm --minify --outdir=./dist --sourcemap=linked --packages=external",
    "test": "vitest run"
  },
  "bin": {
    "pylon": "./dist/index.js"
  },
  "files": [
    "dist"
  ],
  "author": "Nico Schett <nico.schett@cronit.io>",
  "license": "Apache-2.0",
  "repository": {
    "type": "git",
    "url": "https://github.com/getcronit/pylon.git",
    "directory": "packages/create-pylon"
  },
  "homepage": "https://pylon.cronit.io",
  "dependencies": {
    "@gqty/cli": "^4.2.5",
    "commander": "^12.1.0",
    "conf": "^13.1.0",
    "consola": "^3.2.3",
    "dotenv": "^16.4.5",
    "esbuild": "^0.23.1",
    "esbuild-plugin-tsc": "^0.4.0",
    "posthog-node": "^4.10.1"
  },
  "publishConfig": {
    "access": "public"
  },
  "engines": {
    "node": ">=18.0.0"
  },
  "devDependencies": {
    "@types/node": "^20.0.0",
    "typescript": "^5.7.3",
    "vitest": "^2.0.0"
  },
  "peerDependencies": {
    "@getcronit/pylon": "workspace:3.0.0-canary-20260328200015.71367b7a9e557a2e0de9a6348e56d450fce33de4",
    "graphql": "^16.9.0"
  }
}
